import { Children, FC, ReactElement, ReactNode, useEffect, useRef, useState, Suspense, cloneElement } from 'react';
import { Spin } from 'antd';

interface MicroApplicationRouterProps {
  childern?: ReactNode;
}

// 过滤出所有为MicroApplicationRoute的组件
const filterRoutChildren = (children: ReactElement) => {
  const micrRoutes: any = [];
  const routes: any = [];
  Children.forEach(children, (child) => {
    const { type } = child as any || {};
    const { displayName } = type || {};
    if (displayName === 'MicroApplicationRoute') {
      micrRoutes.push(child);
    } else {
      routes.push(child);
    }
  });

  return [micrRoutes, routes];
};

// 痛过base进行匹配挂载哪一个组件

const MicroApplicationRouter: FC<MicroApplicationRouterProps> = ({ children }) => {
  const routeMap = useRef<Map<string, ReactNode>>(new Map());
  const routePathname = location.pathname;
  const [micrApp, setMicrApp] = useState<ReactNode>();
  const [micrAppInstance, setMicrAppInstance] = useState<any>();

  // 获取到所有的微应用和非微应用
  const [microRoutes, routes] = filterRoutChildren(children as ReactElement);

  const onMicroAppChange = (micrApp: any) => {
    setMicrAppInstance(micrApp);
  };

  // 检测微应用的pathname是不是唯一
  useEffect(() => {
    if (!Array.isArray(microRoutes)) {
      return;
    }

    routeMap.current.clear();

    microRoutes.forEach((route: ReactElement) => {
      const { props } = route;
      const { pathname } = props || {};
      if (routeMap.current.has(pathname)) {
        console.error('微应用的pathname必须唯一');
      } else {
        routeMap.current.set(pathname, route);
      }
    });
  }, [microRoutes]);


  useEffect(() => {
    const microRoute = microRoutes.filter(route => {
      const { props } = route;
      const { pathname } = props || {};
      return routePathname.includes(pathname);
    });

    // 如果存在多个相同的，只取第一个;
    if (microRoute.length) {
      setMicrApp(microRoute[0]);
    } else {
      setMicrApp(null);
    }
  }, [microRoutes, routePathname]);

  // 主要解决qiankun bug, 加载新的微应用之前需要卸载之前的微应用，不然就报错
  useEffect(() => {
    return () => {
      if (micrAppInstance && typeof micrAppInstance.unmount === 'function') {
        micrAppInstance.unmount();
      };
    };
  }, [micrAppInstance]);
  return (
    <>
      <Suspense fallback={(<Spin spinning={true} tip='子应用正在加载中'/>)}>
        {
          micrApp ? cloneElement(micrApp as any, { onMicroAppChange }) : routes.map(route => {
            return route;
          })
        }
      </Suspense>
    </>
  );
};

export default MicroApplicationRouter;
